import { useContext } from "react";
import { Context_UI } from "../../Contexts/Context_UI";

export default function UI_Button({
    id,
    Text,
    Type,
    Icon,
    Icon_Position,
    OnClick,
    Fill,
    Hover_Text,
    State,
    Submit = false,
    className
}) {
    const UI = useContext(Context_UI);

    const Icon_Render = () => {
        if (!Icon) return null;

        if (typeof Icon === "string") {
            return (
                <img
                    className="General_Button_Icon"
                    src={Icon}
                    draggable="false"
                    loading="lazy"
                    alt=""
                />
            );
        }

        if (typeof Icon === "function" || typeof Icon === "object") {
            // const IconComponent = Icon;
            return Icon;
        }

        return null;
    };

    return (
        <button
            className={`General_Button ${className || undefined}`}
            id={id}
            onClick={OnClick || null}
            Icon_Position={Icon_Position}
            Icon_Only={Type === "Icon" ? "true" : ""}
            Fill_Width={Fill ? "true" : ""}
            title={Hover_Text}
            State={State}
            type={Submit ? "submit" : "button"}
        >
            {(Icon_Position === "Left" || Icon_Position === "Center") && Icon_Render()}
            {Text}
            {Icon_Position === "Right" && Icon_Render()}
        </button>
    );
}
